module.exports = __webpack_public_path__ + "static/img/cont65 (2).2e55d8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont65 (2).jpg
// module id = 9NIn
// module chunks = 0